import { getMod, useReduxSelector } from 'services/hooks';
import { getModComponent } from 'services/utils';

import { Education } from './education';

/**
 * Education screen for gamified education mod
 */
export const GamifiedEducationPage = () => {
  const GamifiedEducationMC = getModComponent(
    getMod('gamifiedEducation')?.screens.GamifiedEducation
  );

  const isShowGamifiedEducation = useReduxSelector((redux) =>
    Boolean(
      redux.player.gamifiedEducation?.sector ||
        redux.mods.gamifiedEducation?.result
    )
  );

  return isShowGamifiedEducation ? <GamifiedEducationMC /> : <Education />;
};
